var helpList;
var customerData;
export default class vendorServicing_help {
  constructor() {
    this.bindEvents();
  }

  bindEvents = () => {
    this.customerHelpList();
  };
  showAllOrderNumberInHelp = () => {
    $.ajax({
      url: baseURL + "api/vendor/allOrders",
      data: {
        Type: "all",
        Offset: 0,
      },
      type: "GET",
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        result.forEach((order) => {
          var item = `<option value="${order.Order.Order_ID}">#${order.Order.Order_No}</option>`;
          $(".CustomerHelpEmailModalOrderNumber").append(item);
        });
      },
      error: (result) => {},
    });
  };
  sendHelpEmail = (event) => {
    //
    //Show account email on help model
    $.ajax({
      type: "GET",
      url: baseURL + "api/vendor/getVendorDetails",
      headers: { Authorization: X_API_KEY },
      success: (res) => {
        customerData = res;
        $(".CustomerHelpEmailId").html(res.Email_Address);
      },
    });
    // $(".CustomerHelpEmailId").html(customerData.Email);
    $(".CustomerHelpEmailSubHeadingId").html(event.currentTarget.value);

    this.showAllOrderNumberInHelp();
    $(".vendorHelpEmailModalSubmitButton").on(
      "click",
      this.verifyHelpEmailDetails,
    );
  };
  sendAwsEmail = (data) => {
    var BodyHtmlForVendor = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
    <html>
      <head>
        <!-- Compiled with Bootstrap Email version: 1.3.1 -->
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
        <meta http-equiv="x-ua-compatible" content="ie=edge">
        <meta name="x-apple-disable-message-reformatting">
        <meta name="viewport" content="width=device-width, initial-scale=1">
        <meta name="format-detection" content="telephone=no, date=no, address=no, email=no">
        <style type="text/css">
          body,table,td{font-family:Helvetica,Arial,sans-serif !important}.ExternalClass{width:100%}.ExternalClass,.ExternalClass p,.ExternalClass span,.ExternalClass font,.ExternalClass td,.ExternalClass div{line-height:150%}a{text-decoration:none}{color:inherit}a[x-apple-data-detectors],u+#body a,#MessageViewBody a{color:inherit;text-decoration:none;font-size:inherit;font-family:inherit;font-weight:inherit;line-height:inherit}img{-ms-interpolation-mode:bicubic}table:not([class^=s-]){font-family:Helvetica,Arial,sans-serif;mso-table-lspace:0pt;mso-table-rspace:0pt;border-spacing:0px;border-collapse:collapse}table:not([class^=s-]) td{border-spacing:0px;border-collapse:collapse}@media screen and (max-width: 600px){.w-lg-48,.w-lg-48>tbody>tr>td{width:auto !important}.w-full,.w-full>tbody>tr>td{width:100% !important}.w-16,.w-16>tbody>tr>td{width:64px !important}.p-lg-10:not(table),.p-lg-10:not(.btn)>tbody>tr>td,.p-lg-10.btn td a{padding:0 !important}.p-2:not(table),.p-2:not(.btn)>tbody>tr>td,.p-2.btn td a{padding:8px !important}.pr-4:not(table),.pr-4:not(.btn)>tbody>tr>td,.pr-4.btn td a,.px-4:not(table),.px-4:not(.btn)>tbody>tr>td,.px-4.btn td a{padding-right:16px !important}.pl-4:not(table),.pl-4:not(.btn)>tbody>tr>td,.pl-4.btn td a,.px-4:not(table),.px-4:not(.btn)>tbody>tr>td,.px-4.btn td a{padding-left:16px !important}.pr-6:not(table),.pr-6:not(.btn)>tbody>tr>td,.pr-6.btn td a,.px-6:not(table),.px-6:not(.btn)>tbody>tr>td,.px-6.btn td a{padding-right:24px !important}.pl-6:not(table),.pl-6:not(.btn)>tbody>tr>td,.pl-6.btn td a,.px-6:not(table),.px-6:not(.btn)>tbody>tr>td,.px-6.btn td a{padding-left:24px !important}.pt-8:not(table),.pt-8:not(.btn)>tbody>tr>td,.pt-8.btn td a,.py-8:not(table),.py-8:not(.btn)>tbody>tr>td,.py-8.btn td a{padding-top:32px !important}.pb-8:not(table),.pb-8:not(.btn)>tbody>tr>td,.pb-8.btn td a,.py-8:not(table),.py-8:not(.btn)>tbody>tr>td,.py-8.btn td a{padding-bottom:32px !important}[class*=s-lg-]>tbody>tr>td{font-size:0 !important;line-height:0 !important;height:0 !important}.s-4>tbody>tr>td{font-size:16px !important;line-height:16px !important;height:16px !important}.s-6>tbody>tr>td{font-size:24px !important;line-height:24px !important;height:24px !important}}
        </style>
      </head>
      <body class="bg-red-100" style="outline: 0; width: 100%; min-width: 100%; height: 100%; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; font-family: Helvetica, Arial, sans-serif; line-height: 24px; font-weight: normal; font-size: 16px; -moz-box-sizing: border-box; -webkit-box-sizing: border-box; box-sizing: border-box; color: #000000; margin: 0; padding: 0; border-width: 0;" bgcolor="#ff385c">
        <table class="bg-red-100 body" valign="top" role="presentation" border="0" cellpadding="0" cellspacing="0" style="outline: 0; width: 100%; min-width: 100%; height: 100%; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; font-family: Helvetica, Arial, sans-serif; line-height: 24px; font-weight: normal; font-size: 16px; -moz-box-sizing: border-box; -webkit-box-sizing: border-box; box-sizing: border-box; color: #000000; margin: 0; padding: 0; border-width: 0;" bgcolor="#ff385c">
          <tbody>
            <tr>
              <td valign="top" style="line-height: 24px; font-size: 16px; margin: 0;" align="left" bgcolor="#ff385c">
                <table class="container" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;">
                  <tbody>
                    <tr>
                      <td align="center" style="line-height: 24px; font-size: 16px; margin: 0; padding: 0 16px;">
                        <!--[if (gte mso 9)|(IE)]>
                          <table align="center" role="presentation">
                            <tbody>
                              <tr>
                                <td width="600">
                        <![endif]-->
                        <table align="center" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%; max-width: 600px; margin: 0 auto;">
                          <tbody>
                            <tr>
                              <td style="line-height: 24px; font-size: 16px; margin: 0;" align="left">
                                <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                  <tbody>
                                    <tr>
                                      <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                        &#160;
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <img class="w-16" src="https://locaso-pro-data-public.s3.ap-south-1.amazonaws.com/Public_Pictures/locasoWhiteWithoutOrange.png" style="height: auto; line-height: 100%; outline: none; text-decoration: none; display: block; width: 64px; border-style: none; border-width: 0;" width="64">
                                <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                  <tbody>
                                    <tr>
                                      <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                        &#160;
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <div class="space-y-4">
                                  <h1 class="text-4xl fw-800" style="padding-top: 0; padding-bottom: 0; font-weight: 800 !important; vertical-align: baseline; font-size: 36px; line-height: 43.2px; margin: 0;" align="left">${customerData.Business_Name} has raised an Issue</h1>
                                  <table class="s-4 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                    <tbody>
                                      <tr>
                                        <td style="line-height: 16px; font-size: 16px; width: 100%; height: 16px; margin: 0;" align="left" width="100%" height="16">
                                          &#160;
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <p class="" style="line-height: 24px; font-size: 16px; width: 100%; margin: 0;" align="left"></p>
                                  <table class="s-4 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                    <tbody>
                                      <tr>
                                        <td style="line-height: 16px; font-size: 16px; width: 100%; height: 16px; margin: 0;" align="left" width="100%" height="16">
                                          &#160;
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                  <tbody>
                                    <tr>
                                      <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                        &#160;
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <table class="card rounded-3xl px-4 py-8 p-lg-10" role="presentation" border="0" cellpadding="0" cellspacing="0" style="border-radius: 24px; border-collapse: separate !important; width: 100%; overflow: hidden; border: 1px solid #e2e8f0;" bgcolor="#ffffff">
                                  <tbody>
                                    <tr>
                                      <td style="line-height: 24px; font-size: 16px; width: 100%; border-radius: 24px; margin: 0; padding: 40px;" align="left" bgcolor="#ffffff">
                                        <h3 class="text-center" style="padding-top: 0; padding-bottom: 0; font-weight: 500; vertical-align: baseline; font-size: 28px; line-height: 33.6px; margin: 0;" align="center">Details</h3>
                                        <p class="text-center text-muted" style="line-height: 24px; font-size: 16px; color: #718096; width: 100%; margin: 0;" align="center">Order #${data.Order.Order_No}</p>
                                        <p class="text-center text-muted" style="line-height: 24px; font-size: 16px; color: #718096; width: 100%; margin: 0;" align="center">Message : ${data.Message}</p>
                                        <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                          <tbody>
                                            <tr>
                                              <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                                &#160;
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        <table class="hr" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;">
                                          <tbody>
                                            <tr>
                                              <td style="line-height: 24px; font-size: 16px; border-top-width: 1px; border-top-color: #e2e8f0; border-top-style: solid; height: 1px; width: 100%; margin: 0;" align="left">
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                          <tbody>
                                            <tr>
                                              <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                                &#160;
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        <p style="line-height: 24px; font-size: 16px; width: 100%; margin: 0;" align="left">If you have any questions, contact us at <a href="" style="color: #0d6efd;"><span class="_cf_email_" data-cfemail="40082930032f3230002538212d302c256e232f2d">customer.support@locaso.com</span></a>.</p>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                  <tbody>
                                    <tr>
                                      <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                        &#160;
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <!--[if (gte mso 9)|(IE)]>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                        <![endif]-->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      <script data-cfasync="false" src="/cdn-cgi/scripts/5c5dd728/cloudflare-static/email-decode.min.js"></script></body>
    </html>`;
    $.ajax({
      url: baseURL + "api/AmazonSesSmtp/sendCustomerHelpEmail",
      type: "POST",
      data: {
        CustomerEmail: customerData.Email_Address,
        Subject: data.Subject,
        BodyText: `CUSTOMER SUPPORT`,
        BodyHtml: BodyHtmlForVendor,
      },
      success: (result) => {
        window.$("#CustomerHelpEmailModal").modal("hide");

        $(".CustomerHelpConfirmationEmailMessage").html(
          "Your Email has been sent Successfully",
        );
        window.$("#CustomerHelpConfirmationEmail").modal("show");
        setTimeout(() => {
          window.$("#CustomerHelpConfirmationEmail").modal("hide");
        }, 3000);
      },
      error: (error) => {
        $(".CustomerHelpConfirmationEmailMessage").html(
          "Some Error occured, Try Again.",
        );
        window.$("#CustomerHelpConfirmationEmail").modal("show");
        setTimeout(() => {
          window.$("#CustomerHelpConfirmationEmail").modal("hide");
        }, 7000);
      },
    });
  };
  verifyHelpEmailDetails = async () => {
    var canSendEmail = true;
    var helpEmailMessage = $("textarea#CustomerHelpEmailMessage").val();
    var helpEmailSubHeading = $(".CustomerHelpEmailSubHeadingId").text();
    var helpEmailOrderId = $(
      ".CustomerHelpEmailModalOrderNumber > option:selected",
    ).val();

    //verify message
    if (helpEmailMessage.length < 6) {
      canSendEmail = false;
      $(".CustomerHelpEmailMessageError").html("Enter Some Message");
      setTimeout(() => {
        $(".CustomerHelpEmailMessageError").html("");
      }, 5000);
    }

    //Verify email

    var email = customerData.Email_status;
    if (email.toLowerCase() == "invalid") {
      canSendEmail = false;
      $(".CustomerHelpEmailIdError").html("Email address is Invalid");
      setTimeout(() => {
        $(".CustomerHelpEmailIdError").html("");
      }, 5000);
    }

    //verify orderID
    var orderExists = false;
    var emailOrderDetails;
    if (helpEmailOrderId == "") {
      canSendEmail = false;
      $(".CustomerHelpEmailModalOrderNumberError").html("Select an Enquiry ID");
      setTimeout(() => {
        $(".CustomerHelpEmailModalOrderNumberError").html("");
      }, 5000);
    } else {
      await new Promise((resolve) => {
        $.ajax({
          url: baseURL + "api/customer/Cart/OrderDetails",
          type: "POST",
          headers: { Authorization: X_API_KEY },
          data: {
            Order_ID: helpEmailOrderId,
          },
          success: (order) => {
            orderExists = true;
            emailOrderDetails = order.Order;
            resolve();
          },
          error: (result) => {
            resolve();
          },
        });
      });

      if (orderExists == false) {
        canSendEmail = false;
        $(".CustomerHelpEmailModalOrderIdError").html(
          "Enter a valid Enquiry ID",
        );
        setTimeout(() => {
          $(".CustomerHelpEmailModalOrderIdError").html("");
        }, 5000);
      } else {
        canSendEmail = true;
      }
    }
    if (canSendEmail == true) {
      var awsEmailSubject;
      helpList.forEach((helpItem) => {
        if (helpItem.SubHeadingID == helpEmailSubHeading) {
          awsEmailSubject = helpItem.SubHeadingTitle;
        }
      });

      var emailData = {
        Subject: awsEmailSubject,
        Message: helpEmailMessage,
        Order: emailOrderDetails,
        customerEmail: customerData.Email_Address,
      };

      this.sendAwsEmail(emailData);
    }
  };
  customerHelpList = () => {
    // $.ajax({
    //   url: baseURL + "api/customer/Help/customerHeadings",
    //   type: "GET",
    //   success: (result) => {
    //     result.forEach((helpItem) => {
    //       $.ajax({
    //         url: baseURL + "api/customer/Help/customerSubHeadings",
    //         type: "POST",
    //         data: {
    //           Parent_ID : helpItem.id,
    //         },
    //         success: (result) => {
    //
    //         },
    //         error: (result) => {
    //
    //         },
    //       });
    //     })
    //   },
    //   error: (result) => {
    //
    //   },
    // });

    $.ajax({
      url: baseURL + "api/customer/Help/customerHeadingsAndSubHeadings",
      type: "GET",
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        helpList = result;
        var parentHelpItem = "";
        result.forEach((helpItem) => {
          if (parentHelpItem == helpItem.HeadingID) {
            var subheading = `<div class="accordion-item">
            <h2 class="accordion-header" id="sub-heading-${helpItem.SubHeadingID}">
                <button class="accordion-button" style="color: #ff385c;" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-${helpItem.SubHeadingID}" aria-expanded="false" aria-controls="collapseOne">
                    ${helpItem.SubHeadingTitle}
                </button>
            </h2>
            <div id="collapse-${helpItem.SubHeadingID}" class="accordion-collapse collapse" aria-labelledby="sub-heading-${helpItem.SubHeadingID}" data-bs-parent="#accordionExample-${helpItem.HeadingID}">
                <div class="accordion-body">
                ${helpItem.SubHeadingDescription}
                <button type="button" class="btn btn-sm rounded-4 text-white mb-2 " style="background-color: #ff385c;" data-bs-toggle="modal" data-bs-target="#CustomerHelpEmailModal" value = "${helpItem.SubHeadingID}">
                Drop an Email
            </button>
                    <strong>
                        <p class="text-muted">We will revert back within 24-48 hours with your query</p>
                    </strong>
                </div>
            </div>
        </div>`;

            $(`.${helpItem.HeadingID}-sub-items`).append(subheading);
          } else {
            var parentAccordian = `<div class="accordion-item">
            <h2 class="accordion-header" id="flush-heading-${helpItem.HeadingID}">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse-${helpItem.HeadingID}" aria-expanded="false" aria-controls="flush-collapseEight">
                    ${helpItem.HeadingTitle}
                </button>
            </h2>
            <div id="flush-collapse-${helpItem.HeadingID}" class="accordion-collapse collapse" aria-labelledby="flush-heading-${helpItem.HeadingID}" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body">
                ${helpItem.HeadingDescription}
                <span class="${helpItem.HeadingID}-inner-accordian">
                    
                  </span>
                </div>
            </div>
        </div>`;
            $(".customerServicingHelpItems").append(parentAccordian);

            //check if inner accordian is necessary
            if (helpItem.SubHeadingID != null) {
              var innerAccordian = `<div class="accordion mt-3 mb-3 ${helpItem.HeadingID}-sub-items" id="accordionExample-${helpItem.HeadingID}">
              <div class="accordion-item">
                  <h2 class="accordion-header" id="sub-heading-${helpItem.SubHeadingID}">
                      <button class="accordion-button" style="color: #ff385c;" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-${helpItem.SubHeadingID}" aria-expanded="false" aria-controls="collapse-${helpItem.SubHeadingID}">
                          ${helpItem.SubHeadingTitle}
                      </button>
                  </h2>
                  <div id="collapse-${helpItem.SubHeadingID}" class="accordion-collapse collapse" aria-labelledby="sub-heading-${helpItem.SubHeadingID}" data-bs-parent="#accordionExample-${helpItem.HeadingID}">
                      <div class="accordion-body">
                      ${helpItem.SubHeadingDescription}
                          <button type="button" class="btn btn-sm rounded-4 text-white mb-2 dropEmailButton" style="background-color: #ff385c;" data-bs-toggle="modal" data-bs-target="#CustomerHelpEmailModal" value="${helpItem.SubHeadingID}">
                              Drop an Email
                          </button>
                          <strong>
                              <p class="text-muted">We will revert back within 24-48 hours with your query</p>
                          </strong>
                      </div>
                  </div>
              </div>
          </div>`;

              $(`.${helpItem.HeadingID}-inner-accordian`).append(
                innerAccordian,
              );
            }
          }
          parentHelpItem = helpItem.HeadingID;
        });
        $(".dropEmailButton").on("click", this.sendHelpEmail);
      },
      error: (result) => {},
    });
  };
}

